import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Placement, TasksStore, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsEye } from '@react-icons/all-files/bs/BsEye';
import { BsEyeSlash } from '@react-icons/all-files/bs/BsEyeSlash';
import { ActiveDisplay } from '../Displays/ActiveDisplay';
import { DisplaysStore } from '../Displays/DisplaysStore';

export interface IFavoriteProps {
    onClick?(display: ActiveDisplay): void;
    readonly showText?: boolean;
    readonly className?: string;
    readonly display: ActiveDisplay;
    readonly id?: string;
    readonly placement?: Placement;
}

@autoinject
@observer
export class FavoriteButton extends React.Component<IFavoriteProps> {
    public render() {
        return (
            <a
                className={this.props.className + ' d-inline-block ' + this.favoritedClass}
                id={this.props.id}
                onClick={this.onClick}
            >
                <Tooltip
                    message={this.props.display.isFavorited ? 'Remove from watchlist' : 'Add to watchlist'}
                    placement={this.props.placement}
                >
                    <em>
                        {this.props.display.isFavorited ? (
                            <BsEye className="favorite-button text-header" />
                        ) : (
                            <BsEyeSlash className="favorite-button text-header" />
                        )}
                    </em>
                    {this.props.showText && this.props.display.isFavorited && <span> Watching</span>}
                    {this.props.showText && !this.props.display.isFavorited && <span> Watch</span>}
                </Tooltip>
            </a>
        );
    }

    @bind
    @action
    private async onClick(event: React.MouseEvent<HTMLAnchorElement>) {
        if (!this.loading) {
            this.loading = true;
            const favoritedText = this.props.display.isFavorited
                ? `Remove ${this.props.display.serialNumber} from watchlist`
                : `Add ${this.props.display.serialNumber} to watchlist`;

            const task = this.tasksStore.startSessionTask(favoritedText);
            try {
                if (this.props.display.isFavorited) {
                    await this.displaysStore.removeFavoriteDisplay(this.props.display.serialNumber);
                } else {
                    await this.displaysStore.addFavoriteDisplay(this.props.display.serialNumber);
                }

                task.complete();
            } catch (e: any) {
                task.error(e);
            } finally {
                this.loading = false;
            }

            if (this.props.onClick) this.props.onClick(this.props.display);
        }

        this.loading = false;
    }

    @computed
    private get favoritedClass() {
        if (this.props.display.isFavorited) {
            return 'favorited';
        } else {
            return 'not-favorited';
        }
    }

    @observable
    private loading: boolean = false;
    @inject
    private displaysStore!: DisplaysStore;
    @inject
    private tasksStore!: TasksStore;
}
